import React from 'react'
import SignupUI from './SignupUI'

const IndexSignup = () => {
    return (
        <>
            <SignupUI />
        </>
    )
}

export default IndexSignup
